import { colors, media } from "lib/theme";
import styled from "styled-components";
import { space } from "styled-system";

const BackgroundImage = styled.section`
  ${space};
  position: relative;
  display: block;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 200px;
  width: 100%;
  background-image: url(${(p) => p.bgImg.small});
  margin-bottom: 32px;
  background-color: ${colors.gray[100]};

  ${media.medium`
    height: 400px;
    background-image: url(${(p) => p.bgImg.medium});
  `}

  ${media.large`
    background-image: url(${(p) => p.bgImg.large});
    margin-bottom: 70px;
  `}
`;

const Hero = (props) => {
  const { images, ...heroProps } = props;
  return <BackgroundImage bgImg={images} {...heroProps} />;
};

export default Hero;
